import wixWindow from 'wix-window';
import wixData from 'wix-data';
import { fireBIEvent } from 'public/bi-events.js'; 
import wixLocation from 'wix-location';
import wixAnimations from 'wix-animations'
import { timeline } from 'wix-animations';
// let timeline1 = wixAnimations.timeline()
// let timeline2 = wixAnimations.timeline()
// let arrowRect;
let url = wixLocation.url;
let baseUrl = wixLocation.baseUrl;
let formFactor = wixWindow.formFactor;
// console.log(url)

$w.onReady(function () {

        $w("#section8").onViewportEnter((event) => {
        setQuotes()
        })


       const timelineObj = timeline()

   $w('#CustomElement1').on('coor', (event) => {
      timelineObj.add($w('#ribbonY'), { y: -event.detail.y, duration: 0}).play()
   })

      $w('#CustomElement2').on('coor', (event) => {
      timelineObj.add($w('#ribbonX'), { x: -event.detail.y, duration: 0}).play()
   })




    let par = url.slice(baseUrl.length, url.length);

        if (wixWindow.formFactor === "Mobile"){
        $w('#ribbonY').hide("slide", {"delay": 50, "duration": 1500, "direction": "top"})
        $w('#ribbonX').hide("slide", {"delay": 50, "duration": 1500, "direction": "left"})  
        $w('#imageX3').onViewportEnter(() => 
            $w('#Header').style.backgroundColor = "rgb(140,186,255)"
        )}

        $w('#ReadMore').onClick(() => {
        const biFields = {
            button_name: 'Read More',
            topic: 'Read More',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

        $w('#ShipStation').onClick(() => {
        const biFields = {
            button_name: 'ShipStation',
            topic: '',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

        $w('#ReadMoreShipStation').onClick(() => {
        const biFields = {
            button_name: 'Read More',
            topic: 'Read More',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

        $w('#Privy').onClick(() => {
        const biFields = {
            button_name: 'Privy',
            topic: '',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

            $w('#ReadMorePrivy').onClick(() => {
        const biFields = {
            button_name: 'Read More',
            topic: 'Read More',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

        $w('#Smileio').onClick(() => {
        const biFields = {
            button_name: 'Smileio',
            topic: '',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

            $w('#ReadMoreSmile').onClick(() => {
        const biFields = {
            button_name: 'Read More',
            topic: 'Read More',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

        $w('#FBAdsWix').onClick(() => {
        const biFields = {
            button_name: 'FBAdsWix',
            topic: '',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

            $w('#ReadMoreWix').onClick(() => {
        const biFields = {
            button_name: 'Read More',
            topic: 'Read More',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

        $w('#Paypal').onClick(() => {
        const biFields = {
            button_name: 'Paypal',
            topic: '',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

        $w('#ReadMorePayPal').onClick(() => {
        const biFields = {
            button_name: 'Read More',
            topic: 'Read More',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

            $w('#Wix365').onClick(() => {
        const biFields = {
            button_name: 'Wix365',
            topic: '',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

        $w('#ReadMoreWix365').onClick(() => {
        const biFields = {
            button_name: 'Read More',
            topic: 'Read More',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })


        $w('#ExploreAllFeatures').onClick(() => {
        const biFields = {
            button_name: 'Explore All Features ',
            topic: 'Explore Feature',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

        $w('#ExploreFBAds').onClick(() => {
        const biFields = {
            button_name: 'Explore FB Ads',
            topic: 'Explore Feature',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

        $w('#ExploreEmailAutomations').onClick(() => {
        const biFields = {
            button_name: 'Explore Email Automations',
            topic: 'Explore Feature',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

        $w('#ExploreGiftCards').onClick(() => {
        const biFields = {
            button_name: 'Explore Gift Cards',
            topic: 'Explore Feature',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

        $w('#MobileGiftCards').onClick(() => {
        const biFields = {
            button_name: 'Explore Gift Cards',
            topic: 'Explore Feature',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })

        $w('#SubscribetoSchoolContainer').onClick(() => {
        const biFields = {
            button_name: $w('#SubscribetoSchoolbtn').label,
            topic: 'Subscribe',
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    })
});

export function section1_viewportLeave(event) {
$w('#HeaderScroll').expand();
}

export function section1_viewportEnter(event) {
$w('#HeaderScroll').collapse();
}


    // $w('#CustomElement1').on('coor', (event) => {
    //     timeline().add($w('#ribbonY'), { y: -event.detail.y, duration: 0})
    //     .play()
    // });

    // $w('#CustomElement2').on('coor', (event) => {
    //     timeline().add($w('#ribbonX'), { x: -event.detail.y, duration: 0 })
    //     .play()
    // });
    //     });



export function setQuotes() {


    let floatDuration = 500
    let floatOptionsShow = {
        "duration": floatDuration,
        "direction": "right"
    };
    let floatOptionsHide = {
        "duration": floatDuration,
        "direction": "left"
    };
    wixData.query("Quotes")
        .ascending("order")
        .find()
        .then((results) => {
            let allQuotes = results.items
            let totalQuotesNum = allQuotes.length
            let currentQuoteIndex = 0
            setQuoteChange()

            function setQuoteChange() {
                let currentQuoteIndexText = currentQuoteIndex + 1
                $w("#textQuotesIndex").text = currentQuoteIndexText + "/" + totalQuotesNum
                $w("#textQuoteA").text = allQuotes[currentQuoteIndex].quote
                $w("#textQuoteB").text = allQuotes[currentQuoteIndex].quote
                $w("#textQuoteNameA").text = allQuotes[currentQuoteIndex].name
                $w("#textQuoteNameB").text = allQuotes[currentQuoteIndex].name
            }

            function setQuoteChangePrev() {
                if ($w("#textQuoteA").isVisible) {
                    $w("#textQuoteA").hide("float", floatOptionsHide);
                    $w("#textQuoteB").show("float", floatOptionsShow);
                    $w("#textQuoteNameA").hide("float", floatOptionsHide);
                    $w("#textQuoteNameB").show("float", floatOptionsShow);
                } else {
                    $w("#textQuoteB").hide("float", floatOptionsHide);
                    $w("#textQuoteA").show("float", floatOptionsShow);
                    $w("#textQuoteNameA").show("float", floatOptionsShow);
                    $w("#textQuoteNameB").hide("float", floatOptionsHide);
                }
            }

            function setQuoteChangeNext() {
                if ($w("#textQuoteA").isVisible) {
                    $w("#textQuoteA").hide("float", floatOptionsShow);
                    $w("#textQuoteB").show("float", floatOptionsHide);
                    $w("#textQuoteNameA").hide("float", floatOptionsShow);
                    $w("#textQuoteNameB").show("float", floatOptionsHide);
                } else {
                    $w("#textQuoteB").hide("float", floatOptionsShow);
                    $w("#textQuoteA").show("float", floatOptionsHide);
                    $w("#textQuoteNameB").hide("float", floatOptionsShow);
                    $w("#textQuoteNameA").show("float", floatOptionsHide);
                }
            }

            let setQuoteChangeNextAnimVal
            // console.log(formFactor)

            $w("#buttonNextQuote").onMouseIn((event) => {
                if (formFactor !== "Mobile") {
                    setQuoteChangeNextAnimVal = 6
                    setQuoteChangeNextAnim()
                }

            });
            $w("#buttonNextQuote").onMouseOut((event) => {
                if (formFactor !== "Mobile") {
                    setQuoteChangeNextAnimVal = -6
                    setQuoteChangeNextAnim()
                }

            });

            function setQuoteChangeNextAnim() {
                let timelineArrowRight = wixAnimations.timeline();
                const arrowRight = $w("#buttonNextQuote");
                timelineArrowRight
                    .add(arrowRight, {
                        "x": setQuoteChangeNextAnimVal,
                        "duration": 150,
                        "easing": "easeOutQuart"
                    })
                timelineArrowRight.play();
            }

            $w("#buttonNextQuote").onClick((event) => {
                setQuoteChangeNextAnimClick()

            });

            let autoNext = setInterval(setQuoteChangeNextAnimClick, 7000);

            $w("#boxQuotesSlider").onMouseIn((event) => {
                clearInterval(autoNext);
            });
            $w("#boxQuotesSlider").onMouseOut((event) => {
                autoNext = setInterval(setQuoteChangeNextAnimClick, 7000);
            });

            function setQuoteChangeNextAnimClick() {
                if (currentQuoteIndex === totalQuotesNum - 1) {
                    currentQuoteIndex = 0
                    setQuoteChange()
                    setQuoteChangeNext()
                } else {
                    currentQuoteIndex++
                    setQuoteChange()
                    setQuoteChangeNext()
                }
            }

            let setQuoteChangePrevAnimVal

            $w("#buttonPrevQuote").onMouseIn((event) => {
                if (formFactor !== "Mobile") {
                    setQuoteChangePrevAnimVal = -6
                    setQuoteChangePrevAnim()
                }

            });
            $w("#buttonPrevQuote").onMouseOut((event) => {
                if (formFactor !== "Mobile") {
                    setQuoteChangePrevAnimVal = 6
                    setQuoteChangePrevAnim()
                }

            });

            function setQuoteChangePrevAnim() {
                let timelineArrowLeft = wixAnimations.timeline();
                const arrowLeft = $w("#buttonPrevQuote");
                timelineArrowLeft
                    .add(arrowLeft, {
                        "x": setQuoteChangePrevAnimVal,
                        "duration": 150,
                        "easing": "easeOutQuart"
                    })
                timelineArrowLeft.play();
            }

            $w("#buttonPrevQuote").onClick((event) => {

                if (currentQuoteIndex === 0) {
                    currentQuoteIndex = totalQuotesNum - 1
                    setQuoteChange()
                    setQuoteChangePrev()
                } else {
                    currentQuoteIndex--
                    setQuoteChange()
                    setQuoteChangePrev()
                }
            });

        })
        .catch((err) => {
            let errorMsg = err;
        });
}
